import { TUserProfileAction } from '../../../models/commonTypes';

export const ActionTiles: { [key: string]: TUserProfileAction; } = {
	USER_DETAILS: 'user-details' as TUserProfileAction,
	RESET_PASSWORD: 'reset-password' as TUserProfileAction,
	ASSURANCE_SETUP: 'assurance-setup' as TUserProfileAction,
	MFA_SETUP: '2fa-setup' as TUserProfileAction,
	USER_IMPERSONATION: 'user-impersonation' as TUserProfileAction,
};